module.exports = __webpack_public_path__ + "img/kefu.eadb2b2d.jpg";